import React, { useRef, useState } from 'react';

export const SiteVideo = ({ name, label }) => {
  const [failed, setFailed] = useState(false);
  const videoRef = useRef(null);

  return (
    <div className="w-full max-w-2xl">
      <video
        ref={videoRef}
        data-testid={`${name}-video`}
        aria-label={label}
        poster={`/media/${name}.jpg`}
        width={752}
        height={416}
        autoPlay
        loop
        muted
        playsInline
        controls
        preload="auto"
        onError={() => setFailed(true)}
        onLoadedData={() => setFailed(false)}
        className="w-full aspect-[752/416] object-contain rounded-2xl shadow-2xl"
      >
        <source src={`/media/${name}.webm`} type="video/webm" />
        <source src={`/media/${name}.mp4`} type="video/mp4" />
        Votre navigateur ne supporte pas la lecture de vidéos.
      </video>
      {failed && (
        <div data-testid={`${name}-video-error`} role="alert" className="mt-3 text-sm text-red-800">
          La vidéo n’a pas pu être chargée.
          <button
            data-testid={`${name}-video-retry-button`}
            type="button"
            onClick={() => videoRef.current?.load()}
            className="ml-2 underline hover:text-red-600 transition-colors"
          >Réessayer</button>
        </div>
      )}
    </div>
  );
};